import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {setPreviewResolution} from '../actions';
import {SearchBox} from '../../../libs/components/SearchBox';
import {useAuth} from '../../../libs/Hooks/useAuth';
import { actions as businessCardActions , selectors as businessCardSelectors} from '../../BusinessCard';
import {ButtonIconContainer} from '../../../libs/components/ButtonIconContainer';
import { Icon } from 'react-icons-kit';
import {mobile} from 'react-icons-kit/fa/mobile';
import {tablet} from 'react-icons-kit/fa/tablet';
import {desktop} from 'react-icons-kit/fa/desktop';
import {save} from 'react-icons-kit/fa/save';
import {ic_power_settings_new} from 'react-icons-kit/md/ic_power_settings_new';
import {ic_note_add} from 'react-icons-kit/md/ic_note_add';
import {externalLink} from 'react-icons-kit/fa/externalLink';


const {fetchCardSettings,updateCardSettings,reset} =  businessCardActions;
const { getBusinessCard } = businessCardSelectors;

const ToolbarLayout = styled.div`
  width: 100%;
  height: 34px;
  background-color: #1e2832;
`;

const ToolbarItem = styled.div`
  display: inline-block;
`;

const ToolbarButton = styled.button`
  background-color: transparent;
  border: solid 1px white;
  border-radius: 10px;
  margin: 5px 3px 5px 3px;
  padding: 2px 5px 2px 5px;
  &:hover{
      background-color: gray;
  }
  &:active{
      background-color: #ededeb;
  }
`;
const resolutions ={
    mobile:{
        height:'740px',
        width:'350px'
    },
    tablet:{
        height:'1280px',
        width:'800px'
    },
    desktop:{
        height:'100%',
        width:'100%'
    }
}

function Toolbar({businessCard,reset,setPreviewResolution,fetchBusinessCard,onPublish}){

    const auth = useAuth();
    const iconsColor = '#d6d6d9';
    const dataSource = `${process.env.REACT_APP_BASE_URL}/api/cards`;

    const searchResultTemplate = (businessCard) => {

        return(
            <div>
                {businessCard.businessName}
            </div>
        );
    }

    return(
        <ToolbarLayout>
            <ToolbarItem>
                <SearchBox placeholder={"search for a card..."} remoteDataSource={dataSource} searchResultTemplate={searchResultTemplate} onClickCallback={(businessCard) => fetchBusinessCard(businessCard.businessName)}/>
            </ToolbarItem>
            <ToolbarItem>
                <ToolbarButton onClick={() => reset()}><ButtonIconContainer color={iconsColor}><Icon icon={ic_note_add}/></ButtonIconContainer></ToolbarButton>
            </ToolbarItem>
            <ToolbarItem>
                <ToolbarButton onClick={() => setPreviewResolution(resolutions.mobile)}><ButtonIconContainer color={iconsColor}><Icon icon={mobile}/></ButtonIconContainer></ToolbarButton>
            </ToolbarItem>
            <ToolbarItem>
                <ToolbarButton onClick={() => setPreviewResolution(resolutions.tablet)}><ButtonIconContainer color={iconsColor}><Icon icon={tablet}/></ButtonIconContainer></ToolbarButton>
            </ToolbarItem>
            <ToolbarItem>
                <ToolbarButton onClick={() => setPreviewResolution(resolutions.desktop)}><ButtonIconContainer color={iconsColor}><Icon icon={desktop}/></ButtonIconContainer></ToolbarButton>
            </ToolbarItem>
            <ToolbarItem>
                <ToolbarButton><ButtonIconContainer color={iconsColor}><Icon icon={externalLink}/></ButtonIconContainer></ToolbarButton>
            </ToolbarItem>
            <ToolbarItem>
                <ToolbarButton onClick={() => onPublish(businessCard.clientInfo.businessname,businessCard)}><ButtonIconContainer color={iconsColor}><Icon icon={save}/></ButtonIconContainer></ToolbarButton>
            </ToolbarItem>
            <ToolbarItem>
                <ToolbarButton onClick={auth.logout}><ButtonIconContainer color={iconsColor}><Icon icon={ic_power_settings_new}/></ButtonIconContainer></ToolbarButton>
            </ToolbarItem>
        </ToolbarLayout>
    );

}

const mapStateToProps = state => ({
    businessCard: getBusinessCard(state)
});

const mapDispatchToProps = dispatch => ({
    reset: () => dispatch(reset()),
    setPreviewResolution: (previewResolution) => dispatch(setPreviewResolution(previewResolution)),
    fetchBusinessCard: (businessName) => dispatch(fetchCardSettings(businessName)),
    onPublish: (businessName,businessCard) => dispatch(updateCardSettings(businessName,businessCard))
});

export default connect(mapStateToProps,mapDispatchToProps)(Toolbar);

